export const DEFAULT_SUPERUSER_ORG_ID = "80699418-110c-45b5-aae5-fd5086f0c34d";
